import React from "react";
import {useSearchParams} from "react-router-dom";
import {BASE_URL_API} from "../Const";
import {ProductUnitComponentWrapper} from "./ProductUnitComponentWrapper";

export default function ProductList() {
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");

    if (!id) return <p>محصولی انتخاب نشده است.</p>;


    return <ProductUnitComponentWrapper route={"product_detail"} product_id={id}/>
}

export class ProductProvider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            cardShopList: [],
            totalOrder: 0,
            openSnackbar: false,
            message: "",
            snackbarType: "success",
            userData: null,
            units: props.units_prop.units,
        }


    }

    componentDidMount() {
        this.getUserData()

    }

    getUserData() {
        fetch(BASE_URL_API + 'user', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                    if (results.code === "200") {
                        this.setState({userData: results.data, name: results.data.name, address: results.data.address})
                    }
                },
                (error) => {
                    console.log("error")

                }
            );
    }
}
